// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6.5 1.5H1.5V6.5H3.5V3.5H6.5V1.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.5 1.5H17.5V3.5H20.5V6.5H22.5V1.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.0549 7.34129L11.9997 3.8453L5.94548 7.34069L11.9991 10.8345L18.0549 7.34129Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.0614 9.06958L12.999 12.5666V19.5778L19.0619 16.0774L19.0614 9.06958Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.999 19.5769V12.5665L4.93841 9.06867L4.9375 16.0774L10.999 19.5769Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3.5 20.5V17.5H1.5V22.5H6.5V20.5H3.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.5 22.5V17.5H20.5V20.5H17.5V22.5H22.5Z"}}]};

const ViewInArFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'view-in-ar-filled',
    ref,
    icon: element,
  },
));

ViewInArFilledIcon.displayName = 'ViewInArFilledIcon';

export default ViewInArFilledIcon;
